import { InModelFalseIcon } from "../icons/objectsTable/inModel/InModelFalseIcon"
import { InModelTrueIcon } from "../icons/objectsTable/inModel/InModelTrueIcon"
import { Tooltip } from "../tooltip/Tooltip"

type Props = { inModelTrain: boolean | null }

export const InModelTrain = ({ inModelTrain }: Props) => {
	return (
		<>
			{inModelTrain ? (
				<Tooltip placement="bottom" text="Included in the latest model train">
					<div data-testid="includedInLatestModelTrain" style={{ width: "fit-content" }}>
						<InModelTrueIcon />
					</div>
				</Tooltip>
			) : (
				<Tooltip placement="bottom" text="Not included in the latest model train">
					<div data-testid="notTncludedInLatestModelTrain" style={{ width: "fit-content" }}>
						<InModelFalseIcon />
					</div>
				</Tooltip>
			)}
		</>
	)
}
